<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  stats: { type: Object, default: () => ({}) },
});

const { t } = useI18n();

const stages = computed(() => [
  {
    key: 'scheduled',
    label: 'Visitas agendadas',
    icon: 'i-lucide-calendar-check',
    value: Number(props.stats.scheduled || 0),
  },
  {
    key: 'done',
    label: 'Visitas realizadas',
    icon: 'i-lucide-circle-check',
    value: Number(props.stats.visits || 0),
  },
  {
    key: 'offers',
    label: 'Propostas',
    icon: 'i-lucide-file-signature',
    value: Number(props.stats.offers || 0),
  },
  {
    key: 'closed',
    label: 'CCV/contrato',
    icon: 'i-lucide-badge-check',
    value: Number(props.stats.closed || props.stats.signed || 0),
  },
]);
</script>

<template>
  <div class="rounded-lais border border-lais-border bg-lais-bg-soft p-4">
    <div class="mb-4 flex items-center justify-between gap-3">
      <div>
        <p class="text-[13px] font-semibold uppercase text-lais-text-muted">
          {{ t('LEADS.JOURNEY.TITLE') }}
        </p>
        <p class="mt-1 text-[13px] text-lais-text-body">
          {{ t('LEADS.JOURNEY.DESCRIPTION') }}
        </p>
      </div>
    </div>
    <ol class="grid gap-3 sm:grid-cols-4">
      <li
        v-for="(stage, index) in stages"
        :key="stage.key"
        class="relative rounded-lais-sm border bg-white px-3 py-3"
        :class="
          stage.value > 0
            ? 'border-lais-primary/30 shadow-lais-card'
            : 'border-lais-border-soft'
        "
      >
        <span
          v-if="index < stages.length - 1"
          class="absolute -right-3 top-1/2 hidden size-5 -translate-y-1/2 place-items-center rounded-full border border-lais-border bg-white text-lais-text-muted sm:grid"
        >
          <span class="i-lucide-chevron-right size-3" aria-hidden="true" />
        </span>
        <div class="flex items-center gap-2">
          <span
            class="grid size-8 place-items-center rounded-full"
            :class="
              stage.value > 0
                ? 'bg-lais-primary text-white'
                : 'bg-lais-bg-muted text-lais-text-muted'
            "
          >
            <span class="size-4" :class="stage.icon" aria-hidden="true" />
          </span>
          <div class="min-w-0">
            <p class="truncate text-[12px] font-semibold text-lais-text">
              {{ stage.label }}
            </p>
            <p
              class="font-redHatDisplay text-[22px] font-semibold text-lais-text"
            >
              {{ stage.value }}
            </p>
          </div>
        </div>
      </li>
    </ol>
  </div>
</template>
